// extracted by mini-css-extract-plugin
export default {"plan-summary":"Fm0kO5","planSummary":"Fm0kO5","lg":"k81oQN","cta":"mML0v3"};